export default __webpack_public_path__ + "static/Mechanic-06ea923f1f034221730188be5397f28e.png";